import { authServiceFactory } from 'src/business/service/auth-service'
import { logger } from 'src/util/logger'

const formatErrorMessage = (warning: string, suggestions: string[], score: number): string => {
  const messages = []
  if (score < 4) messages.push('Increase password complexity.')
  if(!warning && !suggestions.length && score < 4) messages.push('The suggested password is weak. Try improving the complexity of your password by introducing more words. It can be any sentence, quote, or verse from your favourite song.')
  if (warning) messages.push(warning)
  if (suggestions.length) messages.push(...suggestions)
  return messages.join('\n')
}

export const validateStrongPassword = async (password: string): Promise<string | undefined> => {
  try {
    const response = await authServiceFactory().validateStrongPassword({ password })
    const {
      score,
      feedback: { warning, suggestions },
    } = response

    return formatErrorMessage(warning, suggestions, score)
  } catch (err: any) {
    logger().info(err)
  }
}
